import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { contentPreloader } from '../services/contentPreloader';

const CacheStatusWidget: React.FC = () => {
  const [stats, setStats] = useState<any>(null);

  useEffect(() => {
    const loadStats = async () => {
      const data = await contentPreloader.getStats();
      setStats(data);
    };

    loadStats();
    const interval = setInterval(loadStats, 10000); // Update every 10s
    return () => clearInterval(interval);
  }, []);

  if (!stats) return null;

  const healthPercentage = (stats.unused / 15) * 100;
  const isHealthy = stats.unused >= 5;

  return (
    <div className="bg-black/40 border border-white/5 rounded-xl p-4 mt-auto">
      <div className="flex items-center justify-between mb-3">
        <h3 className="text-[10px] font-black text-stone-500 mono tracking-widest uppercase">Content Pool</h3>
        <div className={`w-1.5 h-1.5 rounded-full ${isHealthy ? 'bg-emerald-500' : 'bg-amber-500'} animate-pulse`} />
      </div>

      <div className="space-y-3">
        <div className="flex justify-between items-end">
          <span className="text-[9px] mono text-stone-600 uppercase">Available Units</span>
          <span className="text-sm font-black text-[#C5A059] mono">{stats.unused}</span>
        </div>

        <div className="w-full bg-stone-800 h-1 rounded-full overflow-hidden">
          <motion.div
            className={`h-full ${isHealthy ? 'bg-emerald-500' : 'bg-amber-500'}`}
            initial={{ width: 0 }}
            animate={{ width: `${Math.min(healthPercentage, 100)}%` }}
            transition={{ duration: 1 }}
          />
        </div>

        <div className="grid grid-cols-4 gap-1 pt-2">
          {Object.entries(stats.byType).slice(0, 4).map(([type, count]) => (
            <div key={type} className="text-center">
              <div className="text-[7px] mono text-stone-700 uppercase truncate">{type}</div>
              <div className="text-[10px] font-black text-[#C5A059] mono">{count as number}</div>
            </div>
          ))}
        </div>
      </div>

      <div className="mt-4 pt-3 border-t border-white/5 text-center">
        <p className="text-[8px] mono text-stone-500 tracking-[0.2em] font-bold uppercase">
          Powered by <span className="text-[#C5A059] drop-shadow-[0_0_3px_rgba(197,160,89,0.5)]">TED.TALKS.DZ</span>
        </p>
      </div>
    </div>
  );
};

export default CacheStatusWidget;